// extracted by mini-css-extract-plugin
module.exports = {"pointCon":"_2PRMW","sequence":"_6CgkS","pointer":"_33_D-","pulse":"_3Cz61","bottom":"_3zDe-","top":"_3pkqn","finger":"_3WQeM"};